/** @format */

import deepOmit from './deepOmit';
import moment from 'moment';
import intl from 'react-intl-universal';

function checkVisible(key, elements, elementsIndex) {
  const position = elementsIndex[key];
  return elements[position] && elements[position].props ? elements[position].props.isComponentVisible : false;
}

function checkControlType(key, elements, elementsIndex) {
  const position = elementsIndex[key];
  return elements[position] && elements[position].props
  && elements[position].props.controlTypeName ? elements[position].props.controlTypeName : ""
}

function transformTableDate(key, elements, elementsIndex) {
  const position = elementsIndex[key];
  const resultObj = {
    needUpdate: false,
    value: '',
  };
  if (
    elements[position] &&
    elements[position].controlTypeName === 'Date' &&
    elements[position].props &&
    elements[position].props.value !== ''
  ) {
    resultObj.value = convertFormatEnglishDateFormat(elements[position].props.value);
    resultObj.needUpdate = true;
  }

  return resultObj;
}

function transformRowTables(val, filterKeys, rawElements, rawElementsIndex) {
  let transformedRow = deepOmit(val, filterKeys);
  Object.entries(transformedRow).forEach(([i, row]) => {
    const rowIndexElement = rawElements.find(ele => ele.origRowIndex === parseInt(i));
    const rowElementIndex = rowIndexElement ? rowIndexElement.rowIndex : 0;
    row = row.map(column => {
      const key = column.elementName + rowElementIndex;
      column.IsVisible = checkVisible(key, rawElements, rawElementsIndex);
      const { needUpdate, value } = transformTableDate(key, rawElements, rawElementsIndex);
      if (needUpdate) {
        column.value = value;
      }
      return column;
    });
  });
  return transformedRow;
}

function transformFormValues(formValues) {
  if (!formValues) return { dataRequests: [], tables: [] };

  const { dataRequests, tables, rawElements, rawElementsIndex } = formValues;

  if (Object.entries(rawElements).length === 0 && Object.entries(dataRequests).length === 0) return { dataRequests: [], tables: [] };

  const newDataRequesWithEnglishDates = getFormatEnglishDateFormat(rawElements, dataRequests);

  const transformedDataRequests = Object.entries(newDataRequesWithEnglishDates).map(([key, val]) => ({
    Name: key,
    Value: val,
    IsVisible: checkVisible(key, rawElements, rawElementsIndex),
    controlType: checkControlType(key, rawElements, rawElementsIndex)
  }));

  const filterKeys = ['isUpdated', 'isNewRow'];

  const transformedTables = Object.entries(tables).map(([key, val]) => ({
    Name: key,
    IsVisible: checkVisible(key, rawElements, rawElementsIndex),
    tableRow: transformRowTables(val, filterKeys, rawElements, rawElementsIndex),
  }));

  return { dataRequests: transformedDataRequests, tables: transformedTables };
}

const getFormatEnglishDateFormat = (rawElements, dataRequests) => {
  const { currentLocale } = intl.options;
  if (currentLocale === 'en-us') {
    return dataRequests;
  }

  const newDataRequest = dataRequests;
  const formattedDates = rawElements.filter(control => !control.parentId && control.controlTypeName === 'Date');
  const format = 'DD-MMM-YYYY';

  formattedDates.forEach(date => {
    const value = newDataRequest[date.id];
    newDataRequest[date.id] =
      value === '' || (value && value.indexOf('/') !== -1)
        ? value
        : moment(value, format, currentLocale)
            .locale('en')
            .format(format);
  });
  return newDataRequest;
};

const convertFormatEnglishDateFormat = date => {
  const { currentLocale } = intl.options;
  if (currentLocale === 'en-us') {
    return date;
  }
  const format = 'DD-MMM-YYYY';

  const newDate =
    date === '' || (date && date.indexOf('/') !== -1)
      ? date
      : moment(date, format, currentLocale)
          .locale('en')
          .format(format);

  return newDate;
};

export default transformFormValues;
